interface PaginationProps {
  total: number;
  current: number;
  pageSize: number;
  onChange: (page: number) => void;
}

export default function Pagination({ total, current, pageSize, onChange }: PaginationProps) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  if (pageCount <= 1) return null;

  const pages: (number | string)[] = [];
  const push = (v: number | string) => pages.push(v);
  if (pageCount <= 7) {
    for (let i = 1; i <= pageCount; i += 1) push(i);
  } else {
    push(1);
    if (current > 3) push('...');
    for (let i = Math.max(2, current - 1); i <= Math.min(pageCount - 1, current + 1); i += 1) push(i);
    if (current < pageCount - 2) push('...');
    push(pageCount);
  }

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-3 text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-200"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((p, idx) =>
        typeof p === 'number' ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`h-9 w-9 rounded-md text-sm font-medium transition-colors ${
              p === current
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-700 text-foreground-200 hover:border-primary-500 hover:text-primary-400'
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="px-1 text-foreground-500">
            ...
          </span>
        )
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(pageCount, current + 1))}
        disabled={current === pageCount}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-3 text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-200"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}